var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"wrapper-content"},[_c('LmDataTableBuilder',{attrs:{"isOnEditMode":_vm.isOnEditMode,"slug":_vm.slug}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }